import { render } from "./IqacMeetingView.vue?vue&type=template&id=3487d85a"
import script from "./IqacMeetingView.vue?vue&type=script&lang=js"
export * from "./IqacMeetingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__